<template>
    <section id="produtos" class="projects section-panel">
        <div class="project-copy">
            <div class="section-kicker">Produtos</div>
            <h2>Motoclube App</h2>
            <p class="lead">
                Uma plataforma para digitalizar a rotina administrativa de motoclubes, conectando
                diretoria, integrantes e financeiro em um fluxo simples de acompanhar.
            </p>
            <p>
                O produto reúne área do membro, cadastro de integrantes, controle de mensalidades,
                pagamentos e contas a pagar e receber, ajudando clubes a reduzir planilhas soltas e
                manter a gestão financeira mais transparente.
            </p>
            <div class="project-tags" aria-label="Funcionalidades do Motoclube App">
                <span>Membros</span>
                <span>Mensalidades</span>
                <span>Pagamentos</span>
                <span>Financeiro</span>
            </div>
            <a class="project-link" href="https://www.motoclube.app/" target="_blank" rel="noopener noreferrer">
                Conhecer o Motoclube App
            </a>
        </div>

        <div class="screenshots" aria-label="Prévias visuais do Motoclube App">
            <div class="phone phone-primary">
                <div class="phone-bar"></div>
                <div class="app-header">
                    <span>Motoclube</span>
                    <strong>Mensalidades</strong>
                </div>
                <div class="finance-card active">
                    <small>Próximo vencimento</small>
                    <strong>Mensalidade de agosto</strong>
                    <span>R$ 80,00 · pagar via PIX</span>
                </div>
                <div class="finance-card">
                    <small>Status financeiro</small>
                    <strong>Integrante em dia</strong>
                    <span>Último pagamento em 05/08</span>
                </div>
                <div class="payment-method">
                    <span></span>
                    <strong>QR PIX</strong>
                    <small>copia e cola disponível</small>
                </div>
                <div class="bottom-tabs">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
            <div class="phone phone-secondary">
                <div class="phone-bar"></div>
                <div class="member-card">
                    <span class="avatar">MC</span>
                    <strong>Área do membro</strong>
                    <small>Cadastro completo</small>
                </div>
                <div class="stat-row">
                    <span>Contas a pagar</span>
                    <strong>R$ 1.240</strong>
                </div>
                <div class="stat-row">
                    <span>Contas a receber</span>
                    <strong>R$ 3.680</strong>
                </div>
                <div class="ledger-preview">
                    <span style="width: 78%"></span>
                    <span style="width: 54%"></span>
                    <span style="width: 88%"></span>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'Projects'
}
</script>

<style scoped>
.projects {
    display: grid;
    grid-template-columns: minmax(0, .92fr) minmax(22rem, 1fr);
    gap: 2.2rem;
    overflow: hidden;
}

h2 {
    color: white;
    font-family: "Sora", sans-serif;
    font-size: clamp(2rem, 4vw, 3rem);
    line-height: 1;
    margin-bottom: 1rem;
}

p {
    color: rgba(255, 255, 255, .74);
    font-size: 1.03rem;
    line-height: 1.7;
    margin-bottom: 1rem;
}

.lead {
    color: rgba(255, 255, 255, .9);
    font-size: 1.18rem;
}

.project-tags {
    display: flex;
    flex-wrap: wrap;
    gap: .55rem;
    margin: 1.35rem 0;
}

.project-tags span {
    border: 1px solid rgba(255, 255, 255, .16);
    border-radius: 999px;
    color: rgba(255, 255, 255, .82);
    padding: .45rem .75rem;
    background: rgba(255, 255, 255, .06);
}

.project-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: .4rem;
    background: white;
    color: var(--brand-blue);
    font-weight: 700;
    padding: .8rem 1rem;
    text-decoration: none;
}

.screenshots {
    min-height: 25rem;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    isolation: isolate;
}

.phone {
    width: 14rem;
    min-height: 27rem;
    border: .45rem solid #101027;
    border-radius: 1.8rem;
    background: #f4f6fb;
    box-shadow: 0 1.5rem 4rem rgba(0, 0, 0, .35);
    padding: 1rem;
    color: #111827;
    overflow: hidden;
}

.phone * {
    min-width: 0;
}

.phone strong,
.phone span,
.phone small {
    overflow-wrap: anywhere;
}

.phone strong {
    overflow-wrap: normal;
}

.phone-primary {
    transform: rotate(-5deg) translateX(1rem);
    z-index: 2;
}

.phone-secondary {
    transform: rotate(7deg) translateX(-.4rem) scale(.88);
    opacity: .92;
}

.phone-bar {
    width: 4rem;
    height: .35rem;
    margin: 0 auto 1.2rem;
    border-radius: 999px;
    background: #111827;
    opacity: .25;
}

.app-header {
    color: #111827;
    margin-bottom: 1rem;
}

.app-header span,
.finance-card small,
.member-card small,
.stat-row span,
.payment-method small {
    display: block;
    color: #687083;
    font-size: .75rem;
}

.app-header strong {
    display: block;
    font-family: "Sora", sans-serif;
    font-size: 1.3rem;
    white-space: nowrap;
}

.finance-card,
.member-card,
.stat-row,
.payment-method {
    border-radius: .75rem;
    background: white;
    padding: .85rem;
    margin-bottom: .75rem;
    box-shadow: 0 .5rem 1.5rem rgba(17, 24, 39, .08);
}

.finance-card.active {
    background: #00005a;
    color: white;
}

.finance-card.active small,
.finance-card.active span {
    color: rgba(255, 255, 255, .72);
}

.finance-card strong,
.member-card strong {
    display: block;
    margin: .2rem 0;
}

.payment-method {
    display: grid;
    grid-template-columns: 2.6rem 1fr;
    column-gap: .7rem;
    align-items: center;
}

.payment-method span {
    display: block;
    width: 2.6rem;
    height: 2.6rem;
    border-radius: .35rem;
    background:
        linear-gradient(90deg, #111827 45%, transparent 45% 55%, #111827 55%) 0 0 / .7rem .7rem,
        #eef1f8;
}

.payment-method strong,
.payment-method small {
    grid-column: 2;
}

.bottom-tabs {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: .45rem;
    margin-top: 1.2rem;
}

.bottom-tabs span {
    height: .45rem;
    border-radius: 999px;
    background: #d7dbea;
}

.avatar {
    display: grid;
    place-items: center;
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    background: #00005a;
    color: white;
    font-weight: 800;
    margin-bottom: .8rem;
}

.stat-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.ledger-preview {
    height: 7rem;
    border-radius: .9rem;
    background: #dfe6f5;
    padding: 1rem;
    display: grid;
    gap: .65rem;
    align-content: center;
}

.ledger-preview span {
    display: block;
    height: .65rem;
    border-radius: 999px;
    background: linear-gradient(90deg, #00005a, #4f69d8);
}

@media screen and (max-width: 920px) {
    .projects {
        grid-template-columns: 1fr;
    }

    .screenshots {
        width: min(100%, 36rem);
        min-height: clamp(29rem, 78vw, 36rem);
        margin: .8rem auto 0;
    }

    .phone {
        position: absolute;
        width: clamp(10.5rem, 35vw, 14rem);
        min-height: 27rem;
        padding: clamp(.72rem, 2vw, 1rem);
    }

    .phone-primary {
        left: 12%;
        top: 1rem;
        transform: rotate(-5deg);
    }

    .phone-secondary {
        right: 10%;
        top: 3.2rem;
        transform: rotate(7deg) scale(.88);
    }
}

@media screen and (max-width: 560px) {
    .projects {
        gap: 1rem;
    }

    .screenshots {
        width: min(100%, 24rem);
        min-height: clamp(28rem, 128vw, 34rem);
        margin-top: 1rem;
    }

    .phone {
        width: clamp(8.5rem, 45vw, 11.4rem);
        min-height: clamp(23rem, 112vw, 27rem);
        border-width: .34rem;
        border-radius: 1.35rem;
        padding: clamp(.56rem, 2.8vw, .78rem);
        box-shadow: 0 1rem 2.8rem rgba(0, 0, 0, .32);
    }

    .phone-secondary {
        min-height: clamp(19.5rem, 82vw, 23rem);
    }

    .phone-primary {
        left: max(.65rem, 4%);
        top: .6rem;
    }

    .phone-secondary {
        right: max(.15rem, 1%);
        top: 3.9rem;
    }

    .phone-bar {
        width: 3.15rem;
        height: .28rem;
        margin-bottom: .72rem;
    }

    .app-header {
        margin-bottom: .62rem;
    }

    .app-header span,
    .finance-card small,
    .member-card small,
    .stat-row span,
    .payment-method small {
        font-size: clamp(.5rem, 2.5vw, .68rem);
    }

    .app-header strong {
        font-size: clamp(.95rem, 4.2vw, 1.08rem);
        line-height: .98;
    }

    .finance-card,
    .member-card,
    .stat-row,
    .payment-method {
        border-radius: .58rem;
        padding: clamp(.48rem, 2.5vw, .7rem);
        margin-bottom: .52rem;
    }

    .finance-card strong,
    .member-card strong,
    .stat-row strong,
    .payment-method strong {
        font-size: clamp(.7rem, 3.35vw, .92rem);
        line-height: 1.06;
    }

    .finance-card span {
        font-size: clamp(.68rem, 3.15vw, .88rem);
        line-height: 1.08;
    }

    .payment-method {
        grid-template-columns: 2rem 1fr;
        column-gap: .5rem;
    }

    .payment-method span {
        width: 2rem;
        height: 2rem;
    }

    .bottom-tabs {
        gap: .35rem;
        margin-top: .72rem;
    }

    .bottom-tabs span {
        height: .34rem;
    }

    .avatar {
        width: 2.25rem;
        height: 2.25rem;
        font-size: .82rem;
        margin-bottom: .58rem;
    }

    .ledger-preview {
        height: 5.3rem;
        border-radius: .72rem;
        padding: .78rem;
        gap: .5rem;
    }

    .ledger-preview span {
        height: .52rem;
    }
}

@media screen and (max-width: 390px) {
    .screenshots {
        min-height: clamp(28rem, 138vw, 32rem);
    }

    .phone {
        width: clamp(8rem, 47vw, 9.8rem);
        min-height: clamp(23rem, 116vw, 27rem);
    }

    .phone-primary {
        left: .35rem;
    }

    .phone-secondary {
        right: -.15rem;
        top: 3.75rem;
        transform: rotate(7deg) scale(.84);
    }
}
</style>
